import { render, staticRenderFns } from "./CustomBaseStep.vue?vue&type=template&id=2f5ce7bc"
import script from "./CustomBaseStep.vue?vue&type=script&lang=js"
export * from "./CustomBaseStep.vue?vue&type=script&lang=js"
import style0 from "./CustomBaseStep.vue?vue&type=style&index=0&id=2f5ce7bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports